import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { hideModal, showModal } from '../../../store/reducers/modal'
import '../../../styles/ModalStyles.scss'
import AddNewItem from '../../Modal/components/AddNewItem'
import DeleteModal from '../../Modal/components/DeleteModal'
import EditItem from '../../Modal/components/EditItem'
import ListModal from '../../Modal/components/ListModal'
import STSComponent from "../../STSComponent/STSComponent"
import ClientContacts from './ClientContacts/ClientContacts'
import ClientUsers from './ClientUsers/ClientUsers'

class ModalWrapper extends STSComponent {
  constructor (props) {
    super(props)
    this.state = {
      title: '',
    }
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.openEditModal = this.openEditModal.bind(this)
    this.getData = this.getData.bind(this)
  }

  openEditModal = (type) => () => {
    this.setState({ title: type })
    this.props.showModal(`List-${type}`)
  }

  openModal = (name) => () => {
    this.props.showModal(name)
  }

  closeModal = (name) => () => {
    this.props.hideModal(name)
  }

  returnItemContent = (title, type) => {
    const className = title === 'user'
      ? 'flex-container subjects-wrap user-add'
      : 'flex-container subjects-wrap'
    const { editedItem } = this.state
    return <div className="background-white">
      <div className="get-report-list-container client custom-scroll">
        <div className={className}>
          {title === 'user'
            ? type === 'new' ? <ClientUsers modal newItem /> : <ClientUsers modal editItem={editedItem} />
            : type === 'new' ? <ClientContacts modal newItem /> : <ClientContacts modal editItem={editedItem} />}
        </div>
      </div>
    </div>
  }

  getData = (item) => {
    this.setState({ editedItem: item })
  }

  render () {
    const state = this.state.title
    const { users, data, modal } = this.props
    return <div className="buttons-wrapper">
      {users
        ? <Fragment>
          <div className="client-contact-btn mr-3" onClick={this.openEditModal('user')}>Edit</div>
          <div className="client-contact-btn">Import</div>
        </Fragment>
        : <Fragment>
          <div className="client-contact-btn" onClick={this.openEditModal('contact')}>Edit</div>
        </Fragment>}
      <ListModal
        modalType={state}
        title={state}
        toClose={this.closeModal(`List-${state}`)}
        toAddNew={this.openModal(`Add-new-item-${state}`)}
        openModal={this.openModal}
        listArray={data}
        itemText={''}
        sendData={this.getData}
        modal={modal}
      />
      <AddNewItem
        modalType={state}
        title={`client ${state}`}
        toCancel={this.closeModal(`Add-new-item-${state}`)}
        toAdd={this.closeModal(`Add-new-item-${state}`)}
        content={this.returnItemContent(state, 'new')}
        customStyles="add"
        modal={modal}
      />
      <DeleteModal
        title={state}
        toDelete={this.closeModal(`Delete-${state}`)}
        toCancel={this.closeModal(`Delete-${state}`)}
        modal={modal}
      />
      <EditItem
        modalType={state}
        title={`client ${state}`}
        toCancel={this.closeModal(`Edit-item-${state}`)}
        toSave={this.closeModal(`Edit-item-${state}`)}
        content={this.returnItemContent(state, 'edit')}
        customStyles="add"
        saveButton="save"
        modal={modal}
      />
    </div>
  }

  static propTypes = {
    users: PropTypes.bool,
    showModal: PropTypes.func,
    data: PropTypes.array,
    hideModal: PropTypes.func,
    modal: PropTypes.object
  }
}

export default connect(state => ({
  modal: state.modal
}), {
  showModal,
  hideModal
})(ModalWrapper)



// WEBPACK FOOTER //
// ./src/components/ClientContacts/components/ModalWrapper.js